import React from 'react';

interface DriverInfoProps {
  avatarDriverSelected?: string;
  nameDriverSelected?: string;
}

const DriverInfo: React.FC<DriverInfoProps> = ({
  avatarDriverSelected,
  nameDriverSelected
}) => (
  <div className="display-flex align-items-center gap-10">
    <div
      className="width-30 height-30 rounded-circle aspect-ratio-1 bg-size-100pct bg-repeat-no bg-light"
      style={{
        backgroundImage: `url(${avatarDriverSelected || "https://cdn.rio.cloud/svg/common/ico_rio_colored.svg"})`,
      }}
    />

    <div>
      <span className="text-size-16 text-normal line-height-20 text-capitalize">
        {nameDriverSelected}
      </span>
    </div>
  </div>
);

export default DriverInfo; 